import axios, { AxiosResponse } from "axios";

import { Content, RequestInputs } from "../../types";
import ValidateFiles from "./validateFiles";

export default class UploadAttachments extends ValidateFiles {
  private async sendRequestToS3(
    file: File,
    action: string,
    requestInputs: RequestInputs,
  ): Promise<AxiosResponse<any>> {
    return axios.post(action, this.getFormDataToUploadS3(file, requestInputs));
  }

  async sendAttachmentsToS3(presignedRequestsContent: Content[]) {
    return Promise.allSettled([
      ...presignedRequestsContent.map(async (item, i) => {
        const { action } = item.token.requestAttributes;
        const { requestInputs } = item.token;

        const result = await this.sendRequestToS3(
          this._files[i],
          action,
          requestInputs,
        );
        const promiseFileName = this._files[i].name;

        return { result, promiseFileName };
      }),
    ]);
  }

  private getFormDataToUploadS3(file: File, requestInputs: RequestInputs) {
    const formData = new FormData();

    formData.set("key", requestInputs.key);
    formData.set("acl", requestInputs.acl);
    formData.set("X-Amz-Credential", requestInputs["X-Amz-Credential"]);
    formData.set("X-Amz-Algorithm", requestInputs["X-Amz-Algorithm"]);
    formData.set("X-Amz-Date", requestInputs["X-Amz-Date"]);
    formData.set("Policy", requestInputs.Policy);
    formData.set("X-Amz-Signature", requestInputs["X-Amz-Signature"]);
    formData.set("success_action_status", requestInputs.success_action_status);
    formData.set("Content-Type", file.type);
    formData.set("file", file);

    return formData;
  }
}
